import axios from 'axios'
import _ from 'lodash'
import store from '@/store'

function ApiException (code, body) {
  this.code = code
  this.body = body
  this.name = 'ApiException'
}

ApiException.prototype.toString = function () {
  return this.name + ': "' + this.body + '" (' + this.code + ')'
}

export function parseResponse (response) {
  if (!response.data.success) {
    const errorCode = _.get(response, ['data', 'errorCode'], null)

    // Коды ошибок проверки JWT-токенов c 100 по 108
    if (errorCode >= 100 && errorCode <= 108) {
      store.dispatch('logout')
    }

    throw new ApiException(errorCode, response.data.error)
  }

  return response.data.data
}

export default {
  async getSettings() {
    return axios.get(`/api/settings`).then(resp => {
      return resp.data.settings.dpURL
    })
  },
  async login (username, password) {
    return axios.post(`/api/login`, {
      username: username,
      password: password
    }).then(parseResponse)
  },
  async getLastUpdatedDate () {
    return axios.get(`/api/get-last-updated-date`).then(parseResponse)
  },
  async createServiceGroup (serviceGroup) {
    return axios.post(`/api/service-groups/create`, {
      title: serviceGroup.title,
      colorScheme: serviceGroup.colorScheme
    }).then(parseResponse)
  },
  async updateServiceGroup (serviceGroup) {
    return axios.post(`/api/service-groups/update`, {
      id: serviceGroup.id,
      title: serviceGroup.title,
      colorScheme: serviceGroup.colorScheme
    }).then(parseResponse)
  },
  async deleteServiceGroup (serviceGroup) {
    return axios.post(`/api/service-groups/delete`, {
      id: serviceGroup.id
    }).then(parseResponse)
  },
  async createService (service) {
    return axios.post(`/api/services/create`, {
      title: service.title,
      code: service.code,
      price: parseFloat(service.price),
      currency: 'rub',
      initialScopeOfWork: service.initialScopeOfWork,
      contractorId: service.contractorId,
      type: service.type,

    }).then(parseResponse)
  },
  async updateService (service) {
    return axios.post(`/api/services/update`, {
      id: service.id,
      title: service.title,
      code: service.code,
      groupId: service.groupId,
      price: parseFloat(service.price),
      currency: 'rub',
      initialScopeOfWork: service.initialScopeOfWork,
      contractorId: service.contractorId,
      type: service.type,
    }).then(parseResponse)
  },
  async deleteService (service) {
    return axios.post(`/api/services/delete`, {
      id: service.id
    }).then(parseResponse)
  },
  async addServiceToClient (clientService) {
    return axios.post(`/api/services/add-to-client`, {
      serviceId: clientService.serviceId,
      clientId: clientService.clientId,
      price: clientService.price,
      currency: clientService.currency
    }).then(parseResponse)
  },
  async updateClientService (clientService) {
    return axios.post(`/api/services/update-client-service`, {
      id: clientService.id,
      price: clientService.price,
      currency: clientService.currency,
      externalId: clientService.externalId,
      hidden: clientService.hidden,
      contractorId: clientService.contractorId
    }).then(parseResponse)
  },
  async deleteClientService (clientService) {
    return axios.post(`/api/services/delete-client-service`, {
      id: clientService.id
    }).then(parseResponse)
  },
  async getInitialData () {
    return axios.get(`/api/get-initial-data`).then(parseResponse)
  },
  async getAvailableServices () {
    return axios.get(`/api/services/all`).then(parseResponse)
  },
  async getAvailableClients () {
    return axios.get(`/api/clients/all`).then(parseResponse)
  },
  async getAvailableCaseOriginators () {
    return axios.get(`/api/case-originators/all`).then(parseResponse)
  },
  async getAvailableCaseStatuses () {
    return axios.get(`/api/cases/available-statuses`).then(parseResponse)
  },
  async getServicesByClients () {
    return axios.get(`/api/services/services-by-clients`).then(parseResponse)
  },
  async createClient (client) {
    let data = {
      title: client.title,
      email: client.email,
      caseOriginatorId: client.caseOriginatorId,
      originatorClientIds: client.originatorClientIds,
      reportSendMode: client.reportSendMode,
      inviteToDpCasesEmails: client.inviteToDpCasesEmails,
      noHeader: client.noHeader,
      skipCalcStat: client.skipCalcStat,
      address: client.address,
      contractorId: client.contractorId,
      sendToPatientIfClientNoEmail: client.sendToPatientIfClientNoEmail,
      reportMustBePrinted: client.reportMustBePrinted,
      costCenterId: client.costCenterId,
      regionId: client.regionId,
      private: client.private
    }
    return axios.post(`/api/clients/create`, data)
      .then(parseResponse)
  },
  async updateClient (client) {
    let data = {
      id: client.id,
      title: client.title,
      email: client.email,
      caseOriginatorId: client.caseOriginatorId,
      originatorClientIds: client.originatorClientIds,
      reportSendMode: client.reportSendMode,
      inviteToDpCasesEmails: client.inviteToDpCasesEmails,
      noHeader: client.noHeader,
      noStamp: client.noStamp,
      skipCalcStat: client.skipCalcStat,
      address: client.address,
      contractorId: client.contractorId,
      sendToPatientIfClientNoEmail: client.sendToPatientIfClientNoEmail,
      reportMustBePrinted: client.reportMustBePrinted,
      costCenterId: client.costCenterId,
      regionId: client.regionId,
      activeDiscount: client.activeDiscount,
      private: client.private
    }
    return axios.post(`/api/clients/update`, data)
      .then(parseResponse)
  },
  async deleteClient (client) {
    return axios.post(`/api/clients/delete`, {
      id: client.id
    }).then(parseResponse)
  },
  async createClientSpecialist (clientSpecialist) {
    return axios.post(`/api/clients/create-specialist`, clientSpecialist).then(parseResponse)
  },
  async updateClientSpecialist (clientSpecialist) {
    return axios.post(`/api/clients/update-specialist`, clientSpecialist).then(parseResponse)
  },
  async deleteClientSpecialist (clientSpecialistId) {
    return axios.post(`/api/clients/delete-specialist`, {
      id: clientSpecialistId
    }).then(parseResponse)
  },
  async getPurchasedServicesByDays (fromDate, toDate) {
    return axios.get(`/api/cases/get-purchased-services-by-days`, {
      params: {
        from: fromDate,
        to: toDate
      }
    }).then(parseResponse)
  },
  async getCasesWithSamePatient (caseId) {
    return axios.get(`/api/cases/get-with-same-patient`, {
      params: {
        caseId: caseId
      }
    }).then((response) => {
      return response.data
    })
  },
  async getCaseReport (caseId, noSignatures) {
    return axios.get(`/api/cases/get-report`, {
      params: {
        caseId: caseId,
        noSignatures: noSignatures
      },
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/pdf'
      }
    }).then((response) => {
      return response.data
    })
  },
  async caseSendReport (caseId, comment) {
    return axios.post(`/api/cases/send-report`, {
      caseId: caseId,
      comment: comment
    }).then(parseResponse)
  },
  async caseSendReportFile (caseId, fileId, filePath, fileComment) {
    return axios.post(`/api/cases/send-report-file`, {
      caseId: caseId,
      fileId: fileId,
      filePath: filePath,
      fileComment: fileComment
    }).then(parseResponse)
  },
  async holdCase (caseId, reason) {
    return axios.post(`/api/cases/hold`, {
      caseId: caseId,
      reason: reason
    }).then(parseResponse)
  },
  async unholdCase (caseId) {
    return axios.post(`/api/cases/unhold`, {
      caseId: caseId
    }).then(parseResponse)
  },
  async correctCaseEstimatedCompletionDatetime (caseId, hours, reason, mode) {
    return axios.post(`/api/cases/correct-estimated-completion-datetime`, {
      caseId: caseId,
      hours: hours,
      reason: reason,
      mode: mode
    }).then(parseResponse)
  },
  async getCasePrice (caseId) {
    return axios.get(`/api/cases/get-price`, {
      params: {
        caseId: caseId
      }
    }).then(parseResponse)
  },
  async addServiceToCase (caseId, serviceId) {
    return axios.post(`/api/cases/add-service`, {
      caseId: caseId,
      serviceId: serviceId
    }).then(parseResponse)
  },
  async updateCase (updatedCase) {
    return axios.post(`/api/cases/update`, updatedCase).then(parseResponse)
  },
  async changeCaseClient (caseId, newClientId, dryRun = false) {
    return axios.post(`/api/cases/change-client`, {
      id: caseId,
      newClientId: newClientId,
      dryRun: dryRun
    }).then(parseResponse)
  },
  async caseRequestClinicalData (data) {
    return axios.post(`/api/cases/send-request-clinical-data`, data).then(parseResponse)
  },
  async updateCaseInDP (caseId) {
    return axios.post(`/api/cases/update-case-in-dp`, {
      id: caseId
    }).then(parseResponse)
  },
  async removeServiceFromCase (id) {
    return axios.post(`/api/cases/remove-service`, {
      id: id
    }).then(parseResponse)
  },
  async resetServicePrice (id) {
    return axios.post(`/api/cases/reset-service-price`, {
      id: id
    }).then(parseResponse)
  },
  async updateCaseService (id, price, currency, quantity, comment) {
    return axios.post(`/api/cases/update-service`, {
      id: id,
      price: price,
      currency: currency,
      quantity: quantity,
      comment: comment
    }).then(parseResponse)
  },
  async getDiagnosticPerformance () {
    return axios.get(`/api/diagnostic/performance`, {
    }).then(parseResponse)
  },
  async getPreparationPerformance () {
    return axios.get(`/api/preparation/performance`, {
    }).then(parseResponse)
  },
  async getCasesByParams (date, material, stage) {
    return axios.post(`/api/preparation/performance/search`, {
      date: date,
      material: material,
      stage: stage
    }).then(parseResponse)
  },
  async getWdCaseRegistrationStats () {
    return axios.get(`/api/walldash/statistic/cases/registration`).then(parseResponse)
  },
  async getWdGrossingByDoctorsStats () {
    return axios.get(`/api/walldash/statistic/cases/grossing-by-doctors`).then(parseResponse)
  },
  async getWdGrossingByLabManagersStats () {
    return axios.get(`/api/walldash/statistic/cases/grossing-by-labmanagers`).then(parseResponse)
  },
  async getWdGlassesMicrotomedStats () {
    return axios.get(`/api/walldash/statistic/cases/glasses-microtomated`).then(parseResponse)
  },
  async getWdGlassesScannedStats () {
    return axios.get(`/api/walldash/statistic/cases/glasses-scanned`).then(parseResponse)
  },
  async getWdDoctorOwnersStats () {
    return axios.get(`/api/walldash/statistic/cases/doctor-owners`).then(parseResponse)
  },
  async getWdCollaboratorsStats () {
    return axios.get(`/api/walldash/statistic/cases/collaborators`).then(parseResponse)
  },
  async getDashboardActivityByDate (fromDate, toDate, caseOrigin) {
    return axios.get(`/api/stats/cases/activity-by-date`, {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        caseOrigin: caseOrigin
      }
    }).then(parseResponse)
  },
  async getDashboardReportsByDate (fromDate, toDate, caseOrigin) {
    return axios.get(`/api/stats/cases/reports-by-date`, {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        caseOrigin: caseOrigin
      }
    }).then(parseResponse)
  },
  async getDashboardCaseVsMaterials (fromDate, toDate) {
    return axios.get(`/api/stats/cases/date-vs-materials`, {
      params: {
        fromDate: fromDate,
        toDate: toDate
      }
    }).then(parseResponse)
  },
  async getAllCostCenters(deleted = false) {
    if (deleted) {
      return axios.get(`/api/costcenters?deleted=${deleted}`).then(parseResponse)
    }

    return axios.get(`/api/costcenters`).then(parseResponse)
  },
  async getCostCenterByID(id) {
    return axios.get(`/api/costcenters/${id}`).then(parseResponse)
  },
  async updateCostCenterTitle(id, title, type) {
    return axios.put(`/api/costcenters/${id}`, {title, type}).then(parseResponse)
  },
  async deleteCostCenterByID(id) {
    return axios.delete(`/api/costcenters/${id}`).then(parseResponse)
  },
  async createCostCenter(title, type) {
    let result = null
    try {
      result = await axios.post(`/api/costcenters`, {title, type})
    } catch (error) {
      console.error(`Error in createCostCenter: ${error}`)
    }
    return parseResponse(result)
  },
  async createContractor (contractor) {
    contractor.materialTypeId = parseInt(contractor.materialTypeId)
    return axios.post(`/api/contractors/create`, contractor).then(parseResponse)
  },
  async updateContractor (contractor) {
    contractor.id = parseInt(contractor.id)
    contractor.materialTypeId = parseInt(contractor.materialTypeId)
    return axios.post(`/api/contractors/update`, contractor).then(parseResponse)
  },
  async deleteContractor (contractor) {
    contractor.id = parseInt(contractor.id)
    return axios.post(`/api/contractors/delete`, {
      id: contractor.id
    }).then(parseResponse)
  },
  async laboratoryCreate (item) {
    return axios.post(`/api/references/laboratory/create`, item).then(parseResponse)
  },
  async laboratoryUpdate (item) {
    return axios.post(`/api/references/laboratory/update`, item).then(parseResponse)
  },
  async laboratoryDelete (item) {
    return axios.post(`/api/references/laboratory/delete`, {
      id: item.id
    }).then(parseResponse)
  },
  async reactionCreate (item) {
    return axios.post(`/api/references/reaction/create`, item).then(parseResponse)
  },
  async reactionUpdate (item) {
    return axios.post(`/api/references/reaction/update`, item).then(parseResponse)
  },
  async reactionDelete (item) {
    return axios.post(`/api/references/reaction/delete`, {
      id: item.id
    }).then(parseResponse)
  },
  async stainCreate (item) {
    return axios.post(`/api/references/stain/create`, item).then(parseResponse)
  },
  async stainUpdate (item) {
    return axios.post(`/api/references/stain/update`, item).then(parseResponse)
  },
  async stainDelete (item) {
    return axios.post(`/api/references/stain/delete`, {
      id: item.id
    }).then(parseResponse)
  },
  async slideServiceCreate (item) {
    return axios.post(`/api/references/slide-service/create`, item).then(parseResponse)
  },
  async slideServiceUpdate (item) {
    return axios.post(`/api/references/slide-service/update`, item).then(parseResponse)
  },
  async slideServiceDelete (item) {
    return axios.post(`/api/references/slide-service/delete`, {
      id: item.id
    }).then(parseResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api.js